// @flow

import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { pageInfoFragment, ownerFragment } from 'common/fragments/www'
import { viewerFragment } from 'common/fragments'
import { queryStringParse } from 'helpers/search'

const roomReputationListGQL = gql`
  query RoomReputationListContainer ($friendlyId: String!, $page: Int) {
    room(rentType: DAY_TIME, friendlyId: $friendlyId) {
      uid
      breadcrumbs {
        title
        path
      }
      name
      pageTitle
      thumbnails(page:1, perPage:1) {
        results {
          url
        }
      }
      owner {
        ${ownerFragment}
      }
      reputationSummary {
        score
        count
      }
      reputations(page: $page, perPage: 20) {
        results {
          description
          replyReputation
          from {
            ... on User {
              name
              profileImage
              username
            }
          }
          reservation {
            startedAt
            eventTypeText
            eventType
          }
        }
        ${pageInfoFragment}
      }
      space {
        username
        name
        stateText
      }
    }
    promotions(page: 1) {
      results {
        backgroundColor
        backgroundImage
        endedAt
        id
        linkColor
        textColor
        title
      }
    }
    viewer {
      ${viewerFragment}
    }
  }
`

export default function(component: any) {
  return graphql(roomReputationListGQL, {
    options: props => {
      const query = queryStringParse(props.location.search)
      const variables = {
        friendlyId: props.match.params.roomId || '',
        page: parseInt(query.page, 10) || 1,
      }
      return { variables }
    },
  })(component)
}



// WEBPACK FOOTER //
// ./src/containers/pages/RoomReputationListPage/graphql.js